export default __webpack_public_path__ + "static/media/Arrow.7e759bc6.svg";